import React, { useState, useEffect } from 'react';
import Layout from '@/components/Layout';
import AnimatedTransition from '@/components/AnimatedTransition';
import LeagueTable from '@/components/LeagueTable';
import DivisionSelector from '@/components/DivisionSelector';
import { Trophy } from 'lucide-react';
import { useIsMobile } from '@/hooks/use-mobile';
import { useLocation } from 'react-router-dom';
import { supabase } from '@/lib/supabaseClient';
import { useProjectContext } from '@/contexts/ProjectContext';

type Division = {
  id: string;
  name: string;
};

const Standings = () => {
  const { project } = useProjectContext();
  const [divisions, setDivisions] = useState<Division[]>([]);
  const [refreshKey, setRefreshKey] = useState(0);
  const isMobile = useIsMobile();
  const location = useLocation();

  useEffect(() => {
    if (!project?.id) {
      return;
    }

    const fetchDivisions = async () => {
      if (!project.id) {
        return;
      }

      try {
        const { data, error } = await supabase
          .from('divisions')
          .select('id, name')
          .eq('project_id', project.id)
          .order('name');

        if (error) {
          console.error("Error fetching divisions:", error);
        } else {
          if (data) {
            setDivisions(data);
          }
        }
      } catch (err) {
        console.error("Unexpected error fetching divisions:", err);
      }
    };

    fetchDivisions();
  }, [project]);
  
  useEffect(() => {
    if (!divisions.length || !location.hash) return;

    const hash = location.hash.slice(1);
    const targetId = `division-${hash}`;
    const yOffset = -160;

    const scrollWhenReady = () => {
      const el = document.getElementById(targetId);
      if (el) {
        const y = el.getBoundingClientRect().top + window.scrollY + yOffset;
        window.scrollTo({ top: y, behavior: 'smooth' });
      } else {
        requestAnimationFrame(scrollWhenReady);
      }
    };

    const handleLoad = () => {
      scrollWhenReady();
    };

    if (document.readyState === 'complete') {
      scrollWhenReady();
    } else {
      window.addEventListener('load', handleLoad);
    }

    return () => {
      window.removeEventListener('load', handleLoad);
    };
  }, [divisions, location.hash]);

  // Effect to refresh the component when navigated to or when location state changes
  useEffect(() => {
    // Increment the refresh key to force re-render when navigating to this page
    setRefreshKey(prevKey => prevKey + 1);
  }, [location.pathname, location.state]);
  


  if (!project?.id) {
    return (
      <div className="p-4 text-muted-foreground text-center">
        Loading project...
      </div>
    );
  }

  return (
    <AnimatedTransition>
      <div className="mb-6 flex items-center space-x-4 px-2 md:px-0">
        {/* <Trophy className="h-8 w-8 text-[#30702F]" /> */}
        <div>
          {/* <h1 className="text-2xl md:text-3xl font-semibold tracking-tight mb-1">League Standings</h1> */}
          {/* <p className="text-muted-foreground">View current team standings for all divisions</p> */}
        </div>
      </div>
      
      <div className="w-full space-y-8">
        {divisions.map((division) => (
          <div key={`${division.id}-${refreshKey}`} id={`division-${division.id}`}>
            <LeagueTable division={division} />
          </div>
        ))}
      </div>
    </AnimatedTransition>
  );
};

export default Standings;
